import {
  type ModelTriplet,
  RDK_MODEL_FAMILY_BUILTIN,
  RDK_NAMESPACE,
} from '$lib/resource-type';

export const isBuiltinModel = (
  model: ModelTriplet,
  expectedName?: string
): boolean =>
  model.namespace === RDK_NAMESPACE &&
  model.family === RDK_MODEL_FAMILY_BUILTIN &&
  (expectedName === undefined || model.name === expectedName);
